export default {
    SET_LOADING(state, isLoading) {
        state.isLoading = isLoading;
    },

    SET_LOAD_ERROR(state, loadError) {
        state.loadError = loadError;
    },

    SET_SUMMARY(
        state,
        {
            ranking,
            overall,
            categoryChart,
            categoryList,
            ratedShare,
            topRatingsShare,
            departmentBreakdown,
            resolutionTimeBuckets,
            problemCategories,
            recentLowRatings,
        },
    ) {
        state.ranking = ranking;
        state.overall = overall;
        state.categoryChart = categoryChart;
        state.categoryList = categoryList;
        state.ratedShare = ratedShare;
        state.topRatingsShare = topRatingsShare;
        state.departmentBreakdown = departmentBreakdown;
        state.resolutionTimeBuckets = resolutionTimeBuckets;
        state.problemCategories = problemCategories;
        state.recentLowRatings = recentLowRatings;
    },
};
